<table
  class="radius-top-custom"
  #table
  mat-table
  [dataSource]="datasource"
  fxFill
  [ngClass]="isOriginCertificate ? 'isCertificate' : 'notCertificate'"
  [ngStyle]="{ 'background-color': isNewTrade ? '#091a2f' : '#25303d' }"
  *ngIf="datasource.data.length"
>
  <!-- ncm Column -->
  <ng-container matColumnDef="ncm">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.ncm' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element?.ncm?.ncmCode ?? element?.ncm }}
    </td>
  </ng-container>

  <!-- amount Column -->
  <ng-container matColumnDef="amount">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.amount' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.quantity }}
    </td>
  </ng-container>

  <!-- unit Column -->
  <ng-container matColumnDef="unit">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.unit' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element?.unitMeasure?.code ?? element?.unitMeasure }}
    </td>
  </ng-container>

  <!-- grossWeight Column -->
  <ng-container matColumnDef="grossWeight">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.gross-weight' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element?.grossWeight }} {{ element?.unitMeasureWeight?.code ?? element?.unitMeasureWeight ?? 'KG' }}</td>
  </ng-container>

  <!-- netWeight Column -->
  <ng-container matColumnDef="netWeight">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.net-weight' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element?.netWeight }} {{ element?.unitMeasureWeight?.code ?? element?.unitMeasureWeight ?? 'KG' }}</td>
  </ng-container>

  <!-- marks Column -->
  <ng-container matColumnDef="marks">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.marks-and-numbers' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element?.marks ?? element?.marksAndNumbers }}
    </td>
  </ng-container>

  <!-- sif Column -->
  <ng-container matColumnDef="sif">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.sif' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.sif }}
    </td>
  </ng-container>

  <!-- productionDate Column -->
  <ng-container matColumnDef="productionDate">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.production' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element?.productionDate ?? element?.manufactoringDate | ellosDate : false }}
    </td>
  </ng-container>

  <!-- expirationDate Column -->
  <ng-container matColumnDef="expirationDate">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.shelf-life' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.expirationDate | ellosDate : false }}
    </td>
  </ng-container>

  <!-- product value Column -->
  <ng-container matColumnDef="productValue" *ngIf="useProductValue">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.value' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ getCurrencySymbol(globalCurrency, element.productValue) }}
    </td>
  </ng-container>

  <!-- description Column -->
  <ng-container matColumnDef="description">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.description' | translate }}
    </th>
    <td mat-cell *matCellDef="let element" style="padding: 0.5rem 0; width: 30%">
      {{ element.description | truncate : 50 }}
    </td>
  </ng-container>

  <!-- actions Column -->
  <ng-container matColumnDef="actions" *ngIf="!readonlyGrid">
    <th class="primary-header" mat-header-cell *matHeaderCellDef>
      {{ 'easy-trade.new-trade.stepper.product-information.table.action' | translate }}
    </th>
    <td mat-cell *matCellDef="let element; index as i">
      <button mat-icon-button (click)="editProduct(i)" *ngIf="checkEdit()" [disabled]="isEditProduct">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button (click)="deleteProduct(i)" *ngIf="!readonlyGrid">
        <mat-icon>delete</mat-icon>
      </button>

      <button mat-icon-button (click)="upProduct(i)" [disabled]="dataSource.length <= 1">
        <mat-icon>arrow_upward</mat-icon>
      </button>
      <button mat-icon-button (click)="downProduct(i)" [disabled]="dataSource.length <= 1">
        <mat-icon>arrow_downward</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<div
  [ngClass]="isOriginCertificate ? 'radius-bottom-custom' : 'notCertificate'"
  [ngStyle]="{ 'background-color': isNewTrade ? '#091a2f' : '#25303d' }"
  class="container-total-grid"
  fxLayout="row"
  *ngIf="datasource.data.length"
>
  <div fxFlex="50">
    <div class="total-weight" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="20px">
      <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10px">
        <p class="footer-bold">
          {{ 'easy-trade.new-trade.stepper.product-information.table.total-gross-weight' | translate }}
        </p>
        <span>{{ totalWeight }} {{ dataSource[0]?.unitMeasureWeight?.code ?? dataSource[0]?.unitMeasureWeight ?? 'KG' }}</span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10px">
        <p class="footer-bold">
          {{ 'easy-trade.new-trade.stepper.product-information.table.total-net-weight' | translate }}
        </p>
        <span>
          {{ totalNetWeight }}
          {{ dataSource[0]?.unitMeasureWeight?.code ?? dataSource[0]?.unitMeasureWeight ?? 'KG' }}
        </span>
      </div>
    </div>
  </div>
  <div fxFlex="auto">
    <mat-paginator
      #paginator
      [ngClass]="isOriginCertificate ? 'radius-bottom-custom' : 'notCertificate'"
      [ngStyle]="{ 'background-color': isNewTrade ? '#091a2f' : '#25303d' }"
      [length]="datasource.data.length"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  </div>
</div>
